import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import SalesMngCostStatsContainerViewNew from '../../containers/sales_mng_cost_stats_view_new/SalesMngCostStatsContainerViewNew';

const SalesMngCostStatsPageViewNew = () => {
  return (
    <div>
      <BreadcrumbsContainer
        title="예산 관리/판관비사용실적"
        icon="statistics"
      />
      <SalesMngCostStatsContainerViewNew />
    </div>
  );
};

export default SalesMngCostStatsPageViewNew;
